import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { BusinessTypes } from "./business-actions";

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetchingOne: null,
  fetchingAll: null,
  fetchingBusinessesCount: null,
  fetchingCacheBusinesses: null,
  fetchingEnterpriseCustomers: null,
  fetchingEnterpriseCustomersCount: null,
  fetchingBusinessCustomersSearchSummary: null,
  fetchingVerifiedBusinessesDetails: null,
  enablingCardPayments: null,
  overridingCardFees: null,
  overridingMomoFees: null,
  passingFeesOn: null,
  updating: null,
  deleting: null,
  verificationInProgress: null,
  fetchingBusinessVerification: false,
  fetchingInvitationUptake: false,
  fetchingSegment: false,
  fetchingTag: false,
  associatingTagWithBusinessCustomer: false,
  dissociatingTagFromBusinessCustomer: false,
  dissociatingTagId: null,
  dissociatingTagBusinessCustomerId: null,
  associatingSegmentWithBusinessCustomer: false,
  linkingPlanWithBusinessCustomer: false,
  fetchingReportConfigurations: false,
  creatingReportConfiguration: false,
  generatingReportConfigurationId: null,
  deletingReportConfigurationId: null,
  enablingCustomPSP: false,
  togglingReqsEnabled: false,
  creatingSignupReqs: false,
  fetchingSignupReqs: false,
  deletingSignupReq: false,
  fetchingSignupReqExclusions: false,
  creatingSignupReqExclusions: false,
  deletingSignupReqExclusion: false,
  fetchingBusinessesByName: null,
  fetchingBusinessesByNameCount: null,
  creatingSegment: false,
  creatingTag: false,
  creatingTagGroup: false,
  fetchingTagGroups: false,
  updatingTag: false,
  updatingTagGroup: false,
  fetchingTagGroupsGraphed: false,
  fetchingTags: false,

  business: null,
  businesses: null,
  cacheBusinesses: null,
  enterpriseCustomers: null,
  enterpriseCustomersCount: null,
  businessCustomersSearchSummary: null,
  businessesCount: null,
  verifiedBusinessesDetails: null,
  verificationStarted: null,
  businessVerification: null,
  invitationUptake: null,
  segment: null,
  tag: null,
  reportConfigurations: null,
  enableCustomPSP: null,
  signupReqs: null,
  signupReqExclusions: null,
  businessesByName: null,
  businessesByNameCount: null,
  createdSegment: null,
  createdTag: null,
  createdTagGroup: null,
  tagGroups: null,
  updatedTag: {},
  updatedTagGroup: {},
  tagGroupsGraphed: null,
  tags: null,

  errorEnablingCardPayments: null,
  errorOverridingCardFees: null,
  errorOverridingMomoFees: null,
  errorPassingFeesOn: null,
  errorOne: null,
  errorAll: null,
  errorUpdating: null,
  errorDeleting: null,
  errorBusinessesCount: null,
  errorCacheBusinesses: null,
  errorEnterpriseCustomers: null,
  errorEnterpriseCustomersCount: null,
  errorBusinessCustomersSearchSummary: null,
  errorVerifiedBusinessesDetails: null,
  errorVerifying: null,
  errorBusinessVerification: null,
  errorInvitationUptake: null,
  errorSegment: null,
  errorTag: null,
  errorAssociateTagWithBusinessCustomer: null,
  errorDissociateTagFromBusinessCustomer: null,
  errorAssociateSegmentWithBusinessCustomer: null,
  errorLinkPlanWithBusinessCustomer: null,
  errorReportConfigurations: null,
  errorCreateReportConfiguration: null,
  errorGenerateReportConfiguration: null,
  errorDeleteReportConfiguration: null,
  errorEnablingCustomPSP: null,
  errorTogglingReqsEnabled: null,
  errorCreateSignupReqs: null,
  errorFetchSignupReqs: null,
  errorDeleteSignupReq: null,
  errorFetchSignupReqExclusions: null,
  errorCreateSignupReqExclusions: null,
  errorDeleteSignupReqExclusion: null,
  errorBusinessesByName: null,
  errorBusinessesByNameCount: null,
  errorCreateSegment: null,
  errorCreateTag: null,
  errorCreateTagGroup: null,
  updateTagGroupError: null,
  tagGroupsError: null,
  updateTagError: null,
  tagGroupsGraphedError: null,
  errorTags: null
});

/* ------------- Reducers ------------- */

// tag request  from api
export const tagsRequest = (state) => {
  return { ...state, fetchingTags: true, tags: null, errorTags: null }
};

// update tagGroup request 
export const updateTagGroupRequest = (state) => {
  return { ...state, updatingTagGroup: true, updatedTagGroup: {} };
};

// tag group request  from api
export const tagGroupRequest = (state) => {
  return { ...state, fetchingTagGroups: true, tagGroups: null, tagGroupsError: null }
};

// update tag request 
export const updateTagRequest = (state) => {
  return { ...state, updatingTag: true, updatedTag: {} };
};

// request the data from an api
export const createSegmentRequest = (state) => {
  return { ...state, creatingSegment: true, createdSegment: null, errorCreateSegment: null }
}

// request the data from an api
export const createTagRequest = (state) => {
  return { ...state, creatingTag: true, createdTag: null, errorCreateTag: null }
}

// request the data from an api
export const createTagGroupRequest = (state) => {
  return { ...state, creatingTagGroup: true, createdTagGroup: null, errorCreateTagGroup: null }
}

// tag group graphed request  from api
export const tagGroupGraphedRequest = (state) => {
  return { ...state, fetchingTagGroupsGraphed: true, tagGroupsGraphed: null }
};

// request the data from an api
export const businessByNameRequest = (state) => {
  return { ...state, fetchingBusinessesByName: true, businessesByName: null };
};
//businessesByNameCount request the data from an api
export const businessByNameCountRequest = (state) => {
  return { ...state, fetchingBusinessesByNameCount: true, businessesByNameCount: null };
};

// request the data from an api
export const request = (state) => {
  return { ...state, fetchingOne: true, business: null };
};
// request the data from an api
export const allRequest = (state) => {
  return { ...state, fetchingAll: true, business: null };
};
// request the data from an api
export const businessesCountRequest = (state) => {
  return { ...state, fetchingCount: true, count: null };
};
// request to update from an api
export const updateRequest = (state) => {
  return { ...state, updating: true };
};
// request to delete from an api
export const deleteRequest = (state) => {
  return { ...state, deleting: true };
};
// request the filtered Business from an api 
export const cacheBusinessesRequest = (state) => {
  return { ...state, fetchingCacheBusinesses: true, errorCacheBusinesses: null };
};

// request the enterpriseCustomers from an api 
export const enterpriseCustomersRequest = (state) => {
  return { ...state, fetchingEnterpriseCustomers: true, enterpriseCustomers: null };
};

//request the enterprise customers count from an api
export const enterpriseCustomersCountRequest = (state) => {
  return { ...state, fetchingEnterpriseCustomersCount: true, enterpriseCustomersCount: null };
};

export const businessCustomersSearchSummaryRequest = (state) => {
  return { ...state, fetchingBusinessCustomersSearchSummary: true, businessCustomersSearchSummary: null, errorBusinessCustomersSearchSummary: null };
};

//request the verified businesses details from an api
export const approvedBusinessesDetailRequest = (state) => {
  return { ...state, fetchingVerifiedBusinessesDetails: true, verifiedBusinessesDetails: null };
};

// request to enable passing fees from an api
export const passingFeesOnRequest = (state) => {
  return { ...state, passingFeesOn: true };
};

// request to enable card payment from an api
export const enableCardPaymentsRequest = (state) => {
  return { ...state, enablingCardPayments: true };
};

// request to override card fees from an api
export const overrideCardFeesRequest = (state) => {
  return { ...state, overridingCardFees: true };
};

// request to override momo fees from an api
export const overrideMomoFeesRequest = (state) => {
  return { ...state, overridingMomoFees: true };
};

// verification started request from api
export const verificationStartedRequest = (state) => {
  return { ...state, verificationInProgress: true, verificationStarted: null };
};
//business verification request
export const businessVerificationRequest = (state) => {
  return { ...state, fetchingBusinessVerification: true, businessVerification: null }
}

//business invitation uptake request
export const invitationUptakeRequest = (state) => {
  return { ...state, fetchingInvitationUptake: true, invitationUptake: null }
}
//business segment uptake request
export const segmentRequest = (state) => {
  return { ...state, fetchingSegment: true, segment: null }
}
//business tag uptake request
export const tagRequest = (state) => {
  return { ...state, fetchingTag: true, tag: null }
}

export const associateSegmentWithBusinessCustomerRequest = (state) => ({
  ...state,
  associatingSegmentWithBusinessCustomer: true,
  errorAssociateSegmentWithBusinessCustomer: null,
});

export const associateSegmentWithBusinessCustomerSuccess = (state) => ({
  ...state,
  associatingSegmentWithBusinessCustomer: false,
  errorAssociateSegmentWithBusinessCustomer: null,
});

export const associateSegmentWithBusinessCustomerFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    associatingSegmentWithBusinessCustomer: false,
    errorAssociateSegmentWithBusinessCustomer: error,
  };
};

export const associateTagWithBusinessCustomerRequest = (state) => ({
  ...state,
  associatingTagWithBusinessCustomer: true,
  errorAssociateTagWithBusinessCustomer: null,
});

export const associateTagWithBusinessCustomerSuccess = (state) => ({
  ...state,
  associatingTagWithBusinessCustomer: false,
  errorAssociateTagWithBusinessCustomer: null,
});

export const associateTagWithBusinessCustomerFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    associatingTagWithBusinessCustomer: false,
    errorAssociateTagWithBusinessCustomer: error,
  };
};

export const dissociateTagFromBusinessCustomerRequest = (state, action) => ({
  ...state,
  dissociatingTagFromBusinessCustomer: true,
  dissociatingTagId: action.tagId,
  dissociatingTagBusinessCustomerId: action.bcId,
  errorDissociateTagFromBusinessCustomer: null,
});

export const dissociateTagFromBusinessCustomerSuccess = (state) => ({
  ...state,
  dissociatingTagFromBusinessCustomer: false,
  dissociatingTagId: null,
  dissociatingTagBusinessCustomerId: null,
  errorDissociateTagFromBusinessCustomer: null,
});

export const dissociateTagFromBusinessCustomerFailure = (state, action) => ({
  ...state,
  dissociatingTagFromBusinessCustomer: false,
  dissociatingTagId: null,
  dissociatingTagBusinessCustomerId: null,
  errorDissociateTagFromBusinessCustomer: action.error,
});

export const linkPlanWithBusinessCustomerRequest = (state) => ({
  ...state,
  linkingPlanWithBusinessCustomer: true,
  errorLinkPlanWithBusinessCustomer: null,
});

export const linkPlanWithBusinessCustomerSuccess = (state) => ({
  ...state,
  linkingPlanWithBusinessCustomer: false,
  errorLinkPlanWithBusinessCustomer: null,
});

export const linkPlanWithBusinessCustomerFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    linkingPlanWithBusinessCustomer: false,
    errorLinkPlanWithBusinessCustomer: error,
  };
};
export const reportConfigurationsRequest = (state) => {
  return {
    ...state,
    fetchingReportConfigurations: true,
    reportConfigurations: null,
    errorReportConfigurations: null,
    errorGenerateReportConfiguration: null,
    errorDeleteReportConfiguration: null,
  };
};

export const generateReportConfigurationClearError = (state) => ({
  ...state,
  errorGenerateReportConfiguration: null,
});

export const deleteReportConfigurationClearError = (state) => ({
  ...state,
  errorDeleteReportConfiguration: null,
});

export const createReportConfigurationRequest = (state) => {
  return {
    ...state,
    creatingReportConfiguration: true,
    errorCreateReportConfiguration: null,
  };
};

export const generateReportConfigurationRequest = (state, action) => {
  const { configId } = action;
  return {
    ...state,
    generatingReportConfigurationId: configId,
    errorGenerateReportConfiguration: null,
  };
};

export const deleteReportConfigurationRequest = (state, action) => {
  const { configId } = action;
  return {
    ...state,
    deletingReportConfigurationId: configId,
    errorDeleteReportConfiguration: null,
  };
};

//request to enable custom PSP
export const enableCustomPSPRequest = (state) => {
  return { ...state, enablingCustomPSP: true, enableCustomPSP: null, errorEnablingCustomPSP: null }
}

export const toggleReqsEnabledRequest = (state) => {
  return { ...state, togglingReqsEnabled: true, errorTogglingReqsEnabled: null };
};

export const createSignupReqsRequest = (state) => {
  return { ...state, creatingSignupReqs: true, errorCreateSignupReqs: null };
};

export const fetchSignupReqsRequest = (state) => {
  return { ...state, fetchingSignupReqs: true, errorFetchSignupReqs: null };
};

export const deleteSignupReqRequest = (state) => {
  return { ...state, deletingSignupReq: true, errorDeleteSignupReq: null };
};

export const fetchSignupReqExclusionsRequest = (state) => {
  return { ...state, fetchingSignupReqExclusions: true, errorFetchSignupReqExclusions: null };
};

export const createSignupReqExclusionsRequest = (state) => {
  return { ...state, creatingSignupReqExclusions: true, errorCreateSignupReqExclusions: null };
};

export const deleteSignupReqExclusionRequest = (state) => {
  return { ...state, deletingSignupReqExclusion: true, errorDeleteSignupReqExclusion: null };
};

// successful tag request from api
export const tagsSuccess = (state, action) => {
  const { tags } = action;
  return { ...state, fetchingTags: false, errorTags: null, tags };
};

// successful api update
export const updateTagGroupSuccess = (state, action) => {
  const { tagGroup } = action;
  return { ...state, updatingTagGroup: false, updateTagGroupError: null, updatedTagGroup: tagGroup };
};

// successful api update
export const updateTagSuccess = (state, action) => {
  const { tag } = action;
  return { ...state, updatingTag: false, updateTagError: null, updatedTag: tag };
};

// successful tag group request from api
export const tagGroupSuccess = (state, action) => {
  const { tagGroups } = action;
  return { ...state, fetchingTagGroups: false, tagGroupsError: null, tagGroups };
};

//create segment success
export const createSegmentSuccess = (state, action) => {
  const { segmentData } = action
  return { ...state, creatingSegment: false, createdSegment: segmentData, errorCreateSegment: null }
}

//create tag success
export const createTagSuccess = (state, action) => {
  const { tagData } = action
  return { ...state, creatingTag: false, createdTag: tagData, errorCreateTag: null }
}

//create tagGroup success
export const createTagGroupSuccess = (state, action) => {
  const { tagGroupData } = action
  return { ...state, creatingTagGroup: false, createdTagGroup: tagGroupData, errorCreateTagGroup: null }
}

// successful tag group graphed request from api
export const tagGroupGraphedSuccess = (state, action) => {
  const { tagGroupsGraphed } = action;
  return { ...state, fetchingTagGroupsGraphed: false, tagGroupsGraphedError: null, tagGroupsGraphed };
};

// successful api lookup for single entity
export const businessesByNameSuccess = (state, action) => {
  const { businessesByName } = action;
  return { ...state, fetchingBusinessesByName: false, errorBusinessesByName: null, businessesByName };
};
// businessesByNameCount successful api lookup for single entity
export const businessesByNameCountSuccess = (state, action) => {
  const { businessesByNameCount } = action;
  return { ...state, fetchingBusinessesByNameCount: false, errorBusinessesByNameCount: null, businessesByNameCount };
};
// successful api lookup for single entity
export const success = (state, action) => {
  const { business } = action;
  return { ...state, fetchingOne: false, errorOne: null, business };
};
// successful api lookup for all entities
export const allSuccess = (state, action) => {
  const { businesses } = action;
  return { ...state, fetchingAll: false, errorAll: null, businesses };
};
// successful api lookup for all count entities
export const businessesCountSuccess = (state, action) => {
  const { businessesCount } = action;
  return { ...state, fetchingCount: false, errorCount: null, businessesCount: businessesCount };
};
// successful api update
export const updateSuccess = (state, action) => {
  const { business } = action;
  return { ...state, updating: false, errorUpdating: null, business };
};
// successful api delete
export const deleteSuccess = (state) => {
  return { ...state, deleting: false, errorDeleting: null, business: null };
};
// successful api filtered business
export const cacheBusinessesSuccess = (state, action) => {
  const { cacheBusinesses } = action;
  return { ...state, fetchingCacheBusinesses: false, errorCacheBusinesses: null, cacheBusinesses: cacheBusinesses };
};
// successful api for enterprise customers
export const enterpriseCustomersSuccess = (state, action) => {
  const { enterpriseCustomers } = action;
  return { ...state, fetchingEnterpriseCustomers: false, errorEnterpriseCustomers: null, enterpriseCustomers: enterpriseCustomers }
}

// successful api for enterprise customers count
export const enterpriseCustomersCountSuccess = (state, action) => {
  const { enterpriseCustomersCount } = action;
  return { ...state, fetchingEnterpriseCustomersCount: false, errorEnterpriseCustomersCount: null, enterpriseCustomersCount: enterpriseCustomersCount }
}

export const businessCustomersSearchSummarySuccess = (state, action) => {
  const { businessCustomersSearchSummary } = action;
  return { ...state, fetchingBusinessCustomersSearchSummary: false, errorBusinessCustomersSearchSummary: null, businessCustomersSearchSummary };
};

// successfull api for verified businesses detail
export const approvedBusinessesDetailSuccess = (state, action) => {
  const { approvedVerificationDetails } = action;
  return { ...state, fetchingVerifiedBusinessesDetails: false, errorVerifiedBusinessesDetails: null, verifiedBusinessesDetails: approvedVerificationDetails }
}

// successful api for enablingCardPayments
export const enableCardPaymentsSuccess = (state, action) => {
  const { business } = action;
  return { ...state, enablingCardPayments: false, errorEnablingCardPayments: null, business };
};
// successful api for overridingCardFees
export const overrideCardFeesSuccess = (state, action) => {
  const { business } = action;
  return { ...state, overridingCardFees: false, errorOverridingCardFees: null, business };
};
// successful api for overridingMomoFees
export const overrideMomoFeesSuccess = (state, action) => {
  const { business } = action;
  return { ...state, overridingMomoFees: false, errorOverridingMomoFees: null, business };
};

// successful api for passingFeesOn
export const passingFeesOnSuccess = (state, action) => {
  const { business } = action;
  return { ...state, passingFeesOn: false, errorPassingFeesOn: null, business };
};

// successful verification started api request
export const verificationStartedSuccess = (state, action) => {
  const { verificationStarted } = action;
  return { ...state, verificationInProgress: false, verificationStarted, errorVerifying: null, }
};
//successful business verification call
export const businessVerificationSuccess = (state, action) => {
  const { businessVerification } = action;
  return { ...state, fetchingBusinessVerification: false, errorBusinessVerification: null, businessVerification }
}

//successful invitation uptake call
export const invitationUptakeSuccess = (state, action) => {
  const { invitationUptake } = action;
  return { ...state, fetchingInvitationUptake: false, errorInvitationUptake: null, invitationUptake }
}
//successful invitation uptake call
export const segmentSuccess = (state, action) => {
  const { segment } = action;
  return { ...state, fetchingSegment: false, errorSegment: null, segment }
}
//successful invitation uptake call
export const tagSuccess = (state, action) => {
  const { tag } = action;
  return { ...state, fetchingTag: false, errorTag: null, tag }
}

export const reportConfigurationsSuccess = (state, action) => {
  const { reportConfigurations } = action;
  return {
    ...state,
    fetchingReportConfigurations: false,
    errorReportConfigurations: null,
    reportConfigurations,
  };
};

export const createReportConfigurationSuccess = (state) => ({
  ...state,
  creatingReportConfiguration: false,
  errorCreateReportConfiguration: null,
});

export const generateReportConfigurationSuccess = (state) => ({
  ...state,
  generatingReportConfigurationId: null,
  errorGenerateReportConfiguration: null,
});

export const deleteReportConfigurationSuccess = (state) => ({
  ...state,
  deletingReportConfigurationId: null,
  errorDeleteReportConfiguration: null,
});

//successful api to enable custom PSP
export const enableCustomPSPSuccess = (state, action) => {
  const { business } = action;
  return { ...state, enablingCustomPSP: false, enableCustomPSP: business, errorEnablingCustomPSP: null };
}

export const toggleReqsEnabledSuccess = (state, action) => {
  const { business } = action;
  return { ...state, togglingReqsEnabled: false, errorTogglingReqsEnabled: null, business };
};

export const createSignupReqsSuccess = (state, action) => {
  const { signupReqs } = action;
  return { ...state, creatingSignupReqs: false, errorCreateSignupReqs: null, signupReqs };
};

export const fetchSignupReqsSuccess = (state, action) => {
  const { signupReqs } = action;
  return { ...state, fetchingSignupReqs: false, errorFetchSignupReqs: null, signupReqs };
};

export const deleteSignupReqSuccess = (state, action) => {
  const { signupReqs } = action;
  return { ...state, deletingSignupReq: false, errorDeleteSignupReq: null, signupReqs };
};

export const fetchSignupReqExclusionsSuccess = (state, action) => {
  const { signupReqExclusions } = action;
  return { ...state, fetchingSignupReqExclusions: false, errorFetchSignupReqExclusions: null, signupReqExclusions };
};

export const createSignupReqExclusionsSuccess = (state, action) => {
  const { signupReqExclusions } = action;
  return { ...state, creatingSignupReqExclusions: false, errorCreateSignupReqExclusions: null, signupReqExclusions };
};

export const deleteSignupReqExclusionSuccess = (state, action) => {
  const { signupReqExclusions } = action;
  return { ...state, deletingSignupReqExclusion: false, errorDeleteSignupReqExclusion: null, signupReqExclusions };
};

// Something went wrong requesting for tags.
export const tagsFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingTags: false, errorTags: error, tags: null };
};

// Something went wrong updating tag group?
export const updateTagGroupFailure = (state, action) => {
  const { error } = action;
  return { ...state, updatingTagGroup: false, updateTagGroupError: error, updatedTagGroup: {} };
};

// Something went wrong requesting for tag groups.
export const tagGroupFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingTagGroups: false, tagGroupsError: error, tagGroups: null };
};
// Something went wrong updating tag group?
export const updateTagFailure = (state, action) => {
  const { error } = action;
  return { ...state, updatingTag: false, updateTagError: error, updatedTag: {} };
};

// Something went wrong creating a single entity.
export const createTagFailure = (state, action) => {
  const { error } = action
  return { ...state, creatingTag: false, createdTag: null, errorCreateTag: error }
}

// Something went wrong creating a single entity.
export const createSegmentFailure = (state, action) => {
  const { error } = action
  return { ...state, creatingSegment: false, createdSegment: null, errorCreateSegment: error }
}

// Something went wrong creating a single entity.
export const createTagGroupFailure = (state, action) => {
  const { error } = action
  return { ...state, creatingTagGroup: false, createdTagGroup: null, errorCreateTagGroup: error }
}

// Something went wrong requesting for tag groups graphed.
export const tagGroupGraphedFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingTagGroupsGraphed: false, tagGroupsGraphedError: error, tagGroupsGraphed: null };
};

// Something went wrong fetching a single entity.
export const businessByNameRequestFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingBusinessesByName: false, errorBusinessesByName: error, businessesByName: null };
};
// Something went wrong fetching a single entity.
export const businessByNameCountRequestFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingBusinessesByNameCount: false, errorBusinessesByNameCount: error, businessesByNameCount: null };
};

// Something went wrong fetching a single entity.
export const failure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingOne: false, errorOne: error, business: null };
};
// Something went wrong fetching all entities.
export const allFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingAll: false, errorAll: error, businesses: null };
};
// Something went wrong fetching count entities.
export const businessesCountFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingCount: false, errorCount: error, count: null };
};
// Something went wrong updating.
export const updateFailure = (state, action) => {
  const { error } = action;
  return { ...state, updating: false, errorUpdating: error };
};
// Something went wrong deleting.
export const deleteFailure = (state, action) => {
  const { error } = action;
  return { ...state, deleting: false, errorDeleting: error };
};
// Something went fetching filtered business
export const cacheBusinessesFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingCacheBusinesses: false, errorCacheBusinesses: error };
};

// Something went fetching enterprise customers
export const enterpriseCustomersFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingEnterpriseCustomers: false, errorEnterpriseCustomers: error };
};

export const enterpriseCustomersCountFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingEnterpriseCustomersCount: false, errorEnterpriseCustomersCount: error };
};

export const businessCustomersSearchSummaryFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingBusinessCustomersSearchSummary: false, errorBusinessCustomersSearchSummary: error, businessCustomersSearchSummary: null };
};

// something went wrong fetching verified businesseses details
export const approvedBusinessesDetailFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingVerifiedBusinessesDetails: false, errorVerifiedBusinessesDetails: error };
}

// Something went wrong enablingCardPayments.
export const enableCardPaymentsFailure = (state, action) => {
  const { error } = action;
  return { ...state, enablingCardPayments: false, errorEnablingCardPayments: error };
};

// Something went wrong overridingMomoFees
export const overrideMomoFeesFailure = (state, action) => {
  const { error } = action;
  return { ...state, overridingMomoFees: false, errorOverridingMomoFees: error };
};

// Something went wrong overridingMomoFees
export const overrideCardFeesFailure = (state, action) => {
  const { error } = action;
  return { ...state, overridingCardFees: false, errorOverridingCardFees: error };
};

// Something went wrong overridingMomoFees
export const passingFeesOnFailure = (state, action) => {
  const { error } = action;
  return { ...state, passingFeesOn: false, errorPassingFeesOn: error };
};

// Something went wrong for verification started request.
export const verificationStartedFailure = (state, action) => {
  const { error } = action;
  return { ...state, verificationInProgress: false, verificationStarted: null, errorVerifying: error };
};
//something went wrong fetching business verification request
export const businessVerificationFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingBusinessVerification: false, errorBusinessVerification: error, businessVerification: null }
}
//something went wrong fetching invitation uptake request
export const invitationUptakeFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingInvitationUptake: false, errorInvitationUptake: error, invitationUptake: null }
}
//something went wrong fetching invitation uptake request
export const segmentFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingTag: false, errorTag: error, tag: null }
}
//something went wrong fetching invitation uptake request
export const tagFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingTag: false, errorTag: error, tag: null }
}

export const reportConfigurationsFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetchingReportConfigurations: false,
    errorReportConfigurations: error,
    reportConfigurations: null,
  };
};

export const createReportConfigurationFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    creatingReportConfiguration: false,
    errorCreateReportConfiguration: error,
  };
};

export const generateReportConfigurationFailure = (state, action) => {
  const { error } = action;
  const message = typeof error === "string" ? error : null;
  return {
    ...state,
    generatingReportConfigurationId: null,
    errorGenerateReportConfiguration: message,
  };
};

export const deleteReportConfigurationFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    deletingReportConfigurationId: null,
    errorDeleteReportConfiguration: error,
  };
};

//Something went wrong enabling custom PSP
export const enableCustomPSPFailure = (state, action) => {
  const { error } = action;
  return { ...state, enablingCustomPSP: false, enableCustomPSP: null, errorEnablingCustomPSP: error };
};

export const toggleReqsEnabledFailure = (state, action) => {
  const { error } = action;
  return { ...state, togglingReqsEnabled: false, errorTogglingReqsEnabled: error };
};

export const createSignupReqsFailure = (state, action) => {
  const { error } = action;
  return { ...state, creatingSignupReqs: false, errorCreateSignupReqs: error };
};

export const fetchSignupReqsFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingSignupReqs: false, errorFetchSignupReqs: error };
};

export const deleteSignupReqFailure = (state, action) => {
  const { error } = action;
  return { ...state, deletingSignupReq: false, errorDeleteSignupReq: error };
};

export const fetchSignupReqExclusionsFailure = (state, action) => {
  const { error } = action;
  return { ...state, fetchingSignupReqExclusions: false, errorFetchSignupReqExclusions: error };
};

export const createSignupReqExclusionsFailure = (state, action) => {
  const { error } = action;
  return { ...state, creatingSignupReqExclusions: false, errorCreateSignupReqExclusions: error };
};

export const deleteSignupReqExclusionFailure = (state, action) => {
  const { error } = action;
  return { ...state, deletingSignupReqExclusion: false, errorDeleteSignupReqExclusion: error };
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [BusinessTypes.BUSINESS_REQUEST]: request,
  [BusinessTypes.BUSINESSES_BY_NAME_COUNT_REQUEST]: businessByNameCountRequest,
  [BusinessTypes.BUSINESSES_BY_NAME_REQUEST]: businessByNameRequest,
  [BusinessTypes.BUSINESS_ALL_REQUEST]: allRequest,
  [BusinessTypes.BUSINESSES_COUNT_REQUEST]: businessesCountRequest,
  [BusinessTypes.BUSINESS_UPDATE_REQUEST]: updateRequest,
  [BusinessTypes.BUSINESS_DELETE_REQUEST]: deleteRequest,
  [BusinessTypes.CACHE_BUSINESSES_REQUEST]: cacheBusinessesRequest,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_REQUEST]: enterpriseCustomersRequest,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_COUNT_REQUEST]: enterpriseCustomersCountRequest,
  [BusinessTypes.BUSINESS_CUSTOMERS_SEARCH_SUMMARY_REQUEST]: businessCustomersSearchSummaryRequest,
  [BusinessTypes.APPROVED_BUSINESSES_DETAIL_REQUEST]: approvedBusinessesDetailRequest,
  [BusinessTypes.ENABLE_CARD_PAYMENTS_REQUEST]: enableCardPaymentsRequest,
  [BusinessTypes.OVERRIDE_CARD_FEES_REQUEST]: overrideCardFeesRequest,
  [BusinessTypes.OVERRIDE_MOMO_FEES_REQUEST]: overrideMomoFeesRequest,
  [BusinessTypes.PASSING_FEES_ON_REQUEST]: passingFeesOnRequest,
  [BusinessTypes.VERIFICATION_STARTED_REQUEST]: verificationStartedRequest,
  [BusinessTypes.BUSINESS_VERIFICATION_REQUEST]: businessVerificationRequest,
  [BusinessTypes.INVITATION_UPTAKE_REQUEST]: invitationUptakeRequest,
  [BusinessTypes.SEGMENT_REQUEST]: segmentRequest,
  [BusinessTypes.ASSOCIATE_SEGMENT_WITH_BUSINESS_CUSTOMER_REQUEST]:
    associateSegmentWithBusinessCustomerRequest,
  [BusinessTypes.TAG_REQUEST]: tagRequest,
  [BusinessTypes.ASSOCIATE_TAG_WITH_BUSINESS_CUSTOMER_REQUEST]:
    associateTagWithBusinessCustomerRequest,
  [BusinessTypes.DISSOCIATE_TAG_FROM_BUSINESS_CUSTOMER_REQUEST]:
    dissociateTagFromBusinessCustomerRequest,
  [BusinessTypes.LINK_PLAN_WITH_BUSINESS_CUSTOMER_REQUEST]:
    linkPlanWithBusinessCustomerRequest,
  [BusinessTypes.REPORT_CONFIGURATIONS_REQUEST]: reportConfigurationsRequest,
  [BusinessTypes.CREATE_REPORT_CONFIGURATION_REQUEST]: createReportConfigurationRequest,
  [BusinessTypes.GENERATE_REPORT_CONFIGURATION_REQUEST]: generateReportConfigurationRequest,
  [BusinessTypes.DELETE_REPORT_CONFIGURATION_REQUEST]: deleteReportConfigurationRequest,
  [BusinessTypes.GENERATE_REPORT_CONFIGURATION_CLEAR_ERROR]:
    generateReportConfigurationClearError,
  [BusinessTypes.DELETE_REPORT_CONFIGURATION_CLEAR_ERROR]:
    deleteReportConfigurationClearError,
  [BusinessTypes.ENABLE_CUSTOM_PSP_REQUEST]: enableCustomPSPRequest,
  [BusinessTypes.TOGGLE_REQS_ENABLED_REQUEST]: toggleReqsEnabledRequest,
  [BusinessTypes.CREATE_SIGNUP_REQS_REQUEST]: createSignupReqsRequest,
  [BusinessTypes.FETCH_SIGNUP_REQS_REQUEST]: fetchSignupReqsRequest,
  [BusinessTypes.DELETE_SIGNUP_REQ_REQUEST]: deleteSignupReqRequest,
  [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_REQUEST]: fetchSignupReqExclusionsRequest,
  [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_REQUEST]: createSignupReqExclusionsRequest,
  [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_REQUEST]: deleteSignupReqExclusionRequest,
  [BusinessTypes.CREATE_SEGMENT_REQUEST]: createSegmentRequest,
  [BusinessTypes.CREATE_TAG_REQUEST]: createTagRequest,
  [BusinessTypes.CREATE_TAG_GROUP_REQUEST]: createTagGroupRequest,
  [BusinessTypes.UPDATE_TAG_GROUP_REQUEST]: updateTagGroupRequest,
  [BusinessTypes.TAG_GROUP_REQUEST]: tagGroupRequest,
  [BusinessTypes.UPDATE_TAG_REQUEST]: updateTagRequest,
  [BusinessTypes.TAG_GROUP_GRAPHED_REQUEST]: tagGroupGraphedRequest,
  [BusinessTypes.TAGS_REQUEST]: tagsRequest,
  [BusinessTypes.BUSINESS_SUCCESS]: success,
  [BusinessTypes.BUSINESSES_BY_NAME_SUCCESS]: businessesByNameSuccess,
  [BusinessTypes.BUSINESSES_BY_NAME_COUNT_SUCCESS]: businessesByNameCountSuccess,
  [BusinessTypes.BUSINESSES_COUNT_SUCCESS]: businessesCountSuccess,
  [BusinessTypes.BUSINESS_ALL_SUCCESS]: allSuccess,
  [BusinessTypes.BUSINESS_UPDATE_SUCCESS]: updateSuccess,
  [BusinessTypes.BUSINESS_DELETE_SUCCESS]: deleteSuccess,
  [BusinessTypes.CACHE_BUSINESSES_SUCCESS]: cacheBusinessesSuccess,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_SUCCESS]: enterpriseCustomersSuccess,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_COUNT_SUCCESS]: enterpriseCustomersCountSuccess,
  [BusinessTypes.BUSINESS_CUSTOMERS_SEARCH_SUMMARY_SUCCESS]: businessCustomersSearchSummarySuccess,
  [BusinessTypes.APPROVED_BUSINESSES_DETAIL_SUCCESS]: approvedBusinessesDetailSuccess,
  [BusinessTypes.ENABLE_CARD_PAYMENTS_SUCCESS]: enableCardPaymentsSuccess,
  [BusinessTypes.OVERRIDE_CARD_FEES_SUCCESS]: overrideCardFeesSuccess,
  [BusinessTypes.OVERRIDE_MOMO_FEES_SUCCESS]: overrideMomoFeesSuccess,
  [BusinessTypes.PASSING_FEES_ON_SUCCESS]: passingFeesOnSuccess,
  [BusinessTypes.VERIFICATION_STARTED_SUCCESS]: verificationStartedSuccess,
  [BusinessTypes.BUSINESS_VERIFICATION_SUCCESS]: businessVerificationSuccess,
  [BusinessTypes.INVITATION_UPTAKE_SUCCESS]: invitationUptakeSuccess,
  [BusinessTypes.SEGMENT_SUCCESS]: segmentSuccess,
  [BusinessTypes.ASSOCIATE_SEGMENT_WITH_BUSINESS_CUSTOMER_SUCCESS]:
    associateSegmentWithBusinessCustomerSuccess,
  [BusinessTypes.TAG_SUCCESS]: tagSuccess,
  [BusinessTypes.ASSOCIATE_TAG_WITH_BUSINESS_CUSTOMER_SUCCESS]:
    associateTagWithBusinessCustomerSuccess,
  [BusinessTypes.DISSOCIATE_TAG_FROM_BUSINESS_CUSTOMER_SUCCESS]:
    dissociateTagFromBusinessCustomerSuccess,
  [BusinessTypes.LINK_PLAN_WITH_BUSINESS_CUSTOMER_SUCCESS]:
    linkPlanWithBusinessCustomerSuccess,
  [BusinessTypes.REPORT_CONFIGURATIONS_SUCCESS]: reportConfigurationsSuccess,
  [BusinessTypes.CREATE_REPORT_CONFIGURATION_SUCCESS]: createReportConfigurationSuccess,
  [BusinessTypes.GENERATE_REPORT_CONFIGURATION_SUCCESS]: generateReportConfigurationSuccess,
  [BusinessTypes.DELETE_REPORT_CONFIGURATION_SUCCESS]: deleteReportConfigurationSuccess,
  [BusinessTypes.ENABLE_CUSTOM_PSP_SUCCESS]: enableCustomPSPSuccess,
  [BusinessTypes.TOGGLE_REQS_ENABLED_SUCCESS]: toggleReqsEnabledSuccess,
  [BusinessTypes.CREATE_SIGNUP_REQS_SUCCESS]: createSignupReqsSuccess,
  [BusinessTypes.FETCH_SIGNUP_REQS_SUCCESS]: fetchSignupReqsSuccess,
  [BusinessTypes.DELETE_SIGNUP_REQ_SUCCESS]: deleteSignupReqSuccess,
  [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_SUCCESS]: fetchSignupReqExclusionsSuccess,
  [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_SUCCESS]: createSignupReqExclusionsSuccess,
  [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_SUCCESS]: deleteSignupReqExclusionSuccess,
  [BusinessTypes.CREATE_SEGMENT_SUCCESS]: createSegmentSuccess,
  [BusinessTypes.CREATE_TAG_SUCCESS]: createTagSuccess,
  [BusinessTypes.CREATE_TAG_GROUP_SUCCESS]: createTagGroupSuccess,
  [BusinessTypes.UPDATE_TAG_GROUP_SUCCESS]: updateTagGroupSuccess,
  [BusinessTypes.TAG_GROUP_SUCCESS]: tagGroupSuccess,
  [BusinessTypes.UPDATE_TAG_SUCCESS]: updateTagSuccess,
  [BusinessTypes.TAG_GROUP_GRAPHED_SUCCESS]: tagGroupGraphedSuccess,
  [BusinessTypes.TAGS_SUCCESS]: tagsSuccess,
  [BusinessTypes.BUSINESS_FAILURE]: failure,
  [BusinessTypes.BUSINESSES_BY_NAME_COUNT_FAILURE]: businessByNameCountRequestFailure,
  [BusinessTypes.BUSINESSES_BY_NAME_FAILURE]: businessByNameRequestFailure,
  [BusinessTypes.BUSINESS_ALL_FAILURE]: allFailure,
  [BusinessTypes.BUSINESSES_COUNT_FAILURE]: businessesCountFailure,
  [BusinessTypes.BUSINESS_UPDATE_FAILURE]: updateFailure,
  [BusinessTypes.BUSINESS_DELETE_FAILURE]: deleteFailure,
  [BusinessTypes.CACHE_BUSINESSES_FAILURE]: cacheBusinessesFailure,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_FAILURE]: enterpriseCustomersFailure,
  [BusinessTypes.ENTERPRISE_CUSTOMERS_COUNT_FAILURE]: enterpriseCustomersCountFailure,
  [BusinessTypes.BUSINESS_CUSTOMERS_SEARCH_SUMMARY_FAILURE]: businessCustomersSearchSummaryFailure,
  [BusinessTypes.APPROVED_BUSINESSES_DETAIL_FAILURE]: approvedBusinessesDetailFailure,
  [BusinessTypes.ENABLE_CARD_PAYMENTS_FAILURE]: enableCardPaymentsFailure,
  [BusinessTypes.OVERRIDE_CARD_FEES_FAILURE]: overrideCardFeesFailure,
  [BusinessTypes.OVERRIDE_MOMO_FEES_FAILURE]: overrideMomoFeesFailure,
  [BusinessTypes.PASSING_FEES_ON_FAILURE]: passingFeesOnFailure,
  [BusinessTypes.VERIFICATION_STARTED_FAILURE]: verificationStartedFailure,
  [BusinessTypes.BUSINESS_VERIFICATION_FAILURE]: businessVerificationFailure,
  [BusinessTypes.INVITATION_UPTAKE_FAILURE]: invitationUptakeFailure,
  [BusinessTypes.SEGMENT_FAILURE]: segmentFailure,
  [BusinessTypes.ASSOCIATE_SEGMENT_WITH_BUSINESS_CUSTOMER_FAILURE]: associateSegmentWithBusinessCustomerFailure,
  [BusinessTypes.TAG_FAILURE]: tagFailure,
  [BusinessTypes.ASSOCIATE_TAG_WITH_BUSINESS_CUSTOMER_FAILURE]: associateTagWithBusinessCustomerFailure,
  [BusinessTypes.DISSOCIATE_TAG_FROM_BUSINESS_CUSTOMER_FAILURE]:
    dissociateTagFromBusinessCustomerFailure,
  [BusinessTypes.LINK_PLAN_WITH_BUSINESS_CUSTOMER_FAILURE]: linkPlanWithBusinessCustomerFailure,
  [BusinessTypes.REPORT_CONFIGURATIONS_FAILURE]: reportConfigurationsFailure,
  [BusinessTypes.CREATE_REPORT_CONFIGURATION_FAILURE]: createReportConfigurationFailure,
  [BusinessTypes.GENERATE_REPORT_CONFIGURATION_FAILURE]: generateReportConfigurationFailure,
  [BusinessTypes.DELETE_REPORT_CONFIGURATION_FAILURE]: deleteReportConfigurationFailure,
  [BusinessTypes.ENABLE_CUSTOM_PSP_FAILURE]: enableCustomPSPFailure,
  [BusinessTypes.TOGGLE_REQS_ENABLED_FAILURE]: toggleReqsEnabledFailure,
  [BusinessTypes.CREATE_SIGNUP_REQS_FAILURE]: createSignupReqsFailure,
  [BusinessTypes.FETCH_SIGNUP_REQS_FAILURE]: fetchSignupReqsFailure,
  [BusinessTypes.DELETE_SIGNUP_REQ_FAILURE]: deleteSignupReqFailure,
  [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_FAILURE]: fetchSignupReqExclusionsFailure,
  [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_FAILURE]: createSignupReqExclusionsFailure,
  [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_FAILURE]: deleteSignupReqExclusionFailure,
  [BusinessTypes.CREATE_SEGMENT_FAILURE]: createSegmentFailure,
  [BusinessTypes.CREATE_TAG_FAILURE]: createTagFailure,
  [BusinessTypes.CREATE_TAG_GROUP_FAILURE]: createTagGroupFailure,
  [BusinessTypes.UPDATE_TAG_GROUP_FAILURE]: updateTagGroupFailure,
  [BusinessTypes.TAG_GROUP_FAILURE]: tagGroupFailure,
  [BusinessTypes.UPDATE_TAG_FAILURE]: updateTagFailure,
  [BusinessTypes.TAG_GROUP_GRAPHED_FAILURE]: tagGroupGraphedFailure,
  [BusinessTypes.TAGS_FAILURE]: tagsFailure
});
